"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleMaps = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const baseLibrary_1 = require("../baseLibrary");
class MbGoogleMaps extends baseLibrary_1.BaseLibrary {
    async load() {
        if (window.GOOGLE_API_KEY && window.GOOGLE_API_KEY.trim()) {
            this.instance = new web_ui_framework_1.GoogleMaps(window.GOOGLE_API_KEY);
            await this.instance.load();
        }
        else {
            web_ui_framework_1.Log.warn('GoogleMaps: There is no valid GOOGLE_API_KEY configured');
        }
    }
}
const GoogleMaps = new MbGoogleMaps();
exports.GoogleMaps = GoogleMaps;
//# sourceMappingURL=index.js.map